﻿var vm;
(function () {
    'use strict';
    var controllerId = 'equipmentTrackingController';

    angular
        .module('app.controllers')
        .controller(controllerId, equipmentTrackingController);

    //$modal no existe cuando se vincula el bootstrap solo  
    equipmentTrackingController.$inject = ['common', 'datacontext', '$http', '$scope', '$translate', '$timeout', '$state', '$element', '$sce', '$window', '$stateParams', 'vsblockui'];
    
    function equipmentTrackingController(common, datacontext, $http, $scope, $translate, $timeout, $state, $element, $sce, $window, $stateParams, vsblockui) {
        
        vm = this;

        var CONSTANTS = {
            QUANTITY_BASE_SCROLL: 9,
            QUANTITY_BASE_SCROLL_INS: 6,
            QUANTITY_BASE_SCROLL_PTI: 6
        };

        vm.spinnerOptions = {
            radius: 20,
            lines: 11,
            length: 1,
            width: 8,
            speed: 1.7,
            corners: 1.0,
            trail: 100,
            color: '#146794'
        };

        vm.viewEquipmentInformation = false;
        vm.actionSearch = false;
        vm.activityTypeDefault = '';
        vm.operationTypeDefault = '';
        vm.selectedEquipment = {};
        vm.equipmentActivities = [];

        function init() {
            common.activateController().then(function (data) { });
            vm.operationTypeDefault = $translate.instant('views.equipmentTracking.selectOperationTypes');
            vm.activityTypeDefault = $translate.instant('views.equipmentTracking.selectActivityTypes');
            vm.getOperationTypes();
            vm.getActivityTypes();
            $('#txtStartDat').datepicker({
                autoclose: true,
                format: 'dd/mm/yyyy',
            });
            $('#txtEndDat').datepicker({
                autoclose: true,
                format: 'dd/mm/yyyy',
            });
        }
        
        var lbl_All = $translate.instant('views.equipmentTracking.all');

        vm.searchEquipmentInformation = function ($event) {
            if ($('#EquipmentNoTracking').val() === "") {
                if (vm.equipmentSelected) {                    
                    vm.equipmentSelected.originalObject = undefined;
                    // ClearViews();
                }                    
                return;
            } 
            ClearViews();
            return datacontext.equipmenttracking.getEquipmentsByNo($('#EquipmentNoTracking').val()).then(function (data) {
                var eq = { originalObject: $(data)[0] };
                if ($(data)[0]) {
                    vm.viewEquipmentInformation = false;
                    vm.viewEquipmentActivities = false;
                    vm.viewNoResultEquipmentActivities = false;
                    vm.viewErrorEquipmentActivities = false;
                    vm.actionSearch = true;
                    vm.equipmentSelected = eq;
                    vm.getEquipmentTrackingById(eq.originalObject.EquipmentId);
                    toastr.info('Equipo ' + eq.originalObject.EquipmentNo + ' encontrado.');
                }
                else {
                    vm.actionSearch = false;
                    $('#EquipmentNoTracking').val("");
                    toastr.info($translate.instant('views.equipmentTracking.InvalidEquipment'));
                }
                    
            },
                function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
        }

        $scope.getEquipmentsByNo = function (criteria) {            
            return datacontext.equipmenttracking.getEquipmentsByNo(criteria);
        };

        vm.initializeListOperationTypes = function () {
            vm.listOperationTypes = [];
            vm.listOperationTypes.push({ GeneralTableId: null, Translation: vm.operationTypeDefault, Value: null });
            vm.operationTypeModel = vm.listOperationTypes[0];
        };

        vm.initializeListActivityTypes = function () {
            vm.listActivityTypes = [];
            vm.listActivityTypes.push({ EquipmentActivityTypeId: null, Name: vm.activityTypeDefault });
            vm.activityTypeModel = vm.listActivityTypes[0];
        };

        vm.listOperationTypes = [];
        vm.getOperationTypes = function () {
            vm.initializeListOperationTypes();
            return datacontext.equipmenttracking.getOperationTypes().then(function (data) {
                if (data.Result == 1) {
                    angular.forEach(data.DepotOrderOperationTypes, function (value, key) {
                        vm.listOperationTypes.push(value);
                    });
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        vm.listActivityTypes = [];
        vm.getActivityTypes = function () {
            vm.initializeListActivityTypes();
            return datacontext.equipmenttracking.getActivityTypes().then(function (data) {
                if (data.Result == 1) {
                    angular.forEach(data.ActivityTypes, function (value, key) {
                        vm.listActivityTypes.push(value);
                    });
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        vm.startDat = function () {
            $('#txtStartDat').focus();
        }

        vm.endDat = function () {
            $('#txtEndDat').focus();
        }


        vm.formatDisplayDate = function (val) {
            var d = new Date(val);
            return moment(d).format("DD/MM/YYYY HH:mm:ss");
        }

        vm.formatDatePortion = function (val) {
            var n_val = ("0" + val);
            if (n_val.length <= 2)
                return n_val
            else
                return n_val.substr(1, 2);
        }

        vm.clear = function () {
            $scope.$broadcast('angucomplete-alt:clearInput');
            vm.equipmentSelected.originalObject = undefined;
            vm.operationTypeModel = vm.listOperationTypes[0];
            vm.activityTypeModel = vm.listActivityTypes[0];
            vm.datevalstart = '';
            vm.datevalend = '';
            ClearViews();
            $("#EquipmentNoTracking").val("");
        }

        vm.equipmentSelected = {};
        $scope.selectedEquipmentFn = function (selected) {
            if (selected != undefined) {
                vm.viewEquipmentInformation = false;
                vm.viewEquipmentActivities = false;
                vm.viewNoResultEquipmentActivities = false;
                vm.viewErrorEquipmentActivities = false;
                vm.actionSearch = true;
                vm.equipmentSelected = selected;
                vm.getEquipmentTrackingById(selected.originalObject.EquipmentId);
            }
        }
        
        vm.viewEquipmentActivities = false;
        vm.searchStr = '';
        vm.clickBuscar = function () {
            vm.searchEquipmentInformation();
            vm.viewEquipmentActivities = false;
            vm.viewNoResultEquipmentActivities = false;
            vm.viewErrorEquipmentActivities = false;
            //vm.actionSearch = true;
            // vm.buscar();
        }

        vm.sizeTypeName = '';
        vm.sizeTypeNameCode = '';
        vm.ownerName = '';
        vm.shipmentTypeName = '';
        vm.shipmentTypeNameDesc = '';
        vm.vesselName = '';
        vm.BoxCondition = '';
        vm.BoxConditionColor = '';
        vm.PTICondition = '';
        vm.PTIConditionColor = '';
        vm.voyageNumber = '';
        vm.class = '';
        vm.tareWeight = '';
        vm.lastActivity = '';
        vm.lastActivityCode = '';
        vm.grossWeight = '';
        vm.block = '';
        vm.currentLocation = '';
        vm.equipmentNoModel = '';
        vm.preLoadA = false;
        vm.viewNoResultInformation = false;
        vm.viewEquipmentInformation = false;
        vm.viewErrorInformation = false;
        vm.viewAssociatedEquipment = false;

        vm.getEquipmentTrackingById = function (equipmentId) {
            vm.preLoadA = true;            
            return datacontext.equipmenttracking.getEquipmentTrackingById(equipmentId).then(function (data) {                
                if (data.Result == 1) {
                    if (jQuery.isEmptyObject(data.Equipment)) {
                        vm.viewNoResultInformation = true;
                        vm.viewEquipmentInformation = false;
                        vm.viewErrorInformation = false;
                        vm.viewAssociatedEquipment = false;
                    }
                    else {
                        vm.sizeTypeName = data.Equipment.SizeTypeName;
                        vm.sizeTypeNameCode = data.Equipment.SizeTypeNameCode;
                        vm.imageFile = data.Equipment.ImageFile;
                        vm.ownerName = data.Equipment.OwnerName;
                        vm.shipmentTypeName = data.Equipment.ShipmentTypeName;
                        vm.shipmentTypeNameDesc = data.Equipment.ShipmentTypeNameDesc;
                        vm.vesselName = data.Equipment.VesselName;
                        vm.BoxCondition = data.Equipment.BoxCondition;
                        vm.BoxConditionColor = data.Equipment.BoxConditionColor;
                        vm.PTICondition = data.Equipment.PTICondition;
                        vm.PTIConditionColor = data.Equipment.PTIConditionColor ;
                        vm.voyageNumber = data.Equipment.VoyageNumber;
                        vm.class = data.Equipment.Class;
                        vm.tareWeight = data.Equipment.TareWeight;
                        vm.lastActivity = data.Equipment.LastActivity;
                        vm.lastActivityCode = data.Equipment.LastActivityCode;
                        vm.grossWeight = data.Equipment.GrossWeight;
                        vm.block = data.Equipment.Block;
                        vm.currentLocation = data.Equipment.CurrentLocation;
                        vm.equipmentNoModel = vm.equipmentSelected.originalObject.EquipmentNo;
                        vm.viewNoResultInformation = false;
                        vm.viewErrorInformation = false;

                        if (vm.sizeTypeNameCode == "GESE") {
                            vm.viewAssociatedEquipment = true;
                        }
                        else {
                            vm.viewAssociatedEquipment = false;
                        }
                        vm.buscar();
                        vm.viewEquipmentInformation = true;
                    }
                }
                else {
                    vm.viewErrorInformation = true;
                    vm.viewEquipmentInformation = false;
                    vm.viewNoResultInformation = false;
                    vm.viewAssociatedEquipment = false;
                }
                vm.preLoadA = false;
            }, function (err) {
                vm.preLoadA = false;
                vm.viewErrorInformation = true;
                vm.viewEquipmentInformation = false;
                vm.viewNoResultInformation = false;
                vm.viewAssociatedEquipment = false;
                if (err.status)
                    toastr.error(err.info);
            });
        }

        vm.activityDate = '';
        vm.activityType = '';
        vm.boxCondition = '';
        vm.depotOrderNo = '';
        vm.equipmentActivityId = 0;
        vm.operationType = '';
        vm.ptiCondition = '';
        vm.yardName = '';
        vm.fnConvertDateToSQLFormat = function (date) {
            let parseDate = null;
            if (date != undefined && date != '') {
                var splitDate = date.split("/");
                parseDate = splitDate[1] + '/' + splitDate[0] + '/' + splitDate[2];
            }
            return parseDate;
        }
        vm.buscar = function () {
            
            if ($("#EquipmentNoTracking").val() !="" && $("#EquipmentNoTracking").val()!=undefined && $("#EquipmentNoTracking").val()!=null) {
                var model = {
                    EquipmentNo: $("#EquipmentNoTracking").val(),
                    DepotOrderOperationTypeValue: vm.operationTypeModel.Value,
                    EquipmentActivityTypeId: vm.activityTypeModel.EquipmentActivityTypeId,
                    ActivityDateFrom: vm.datevalstart ? vm.fnConvertDateToSQLFormat(vm.datevalstart) : null,
                    ActivityDateTo: vm.datevalend ? vm.fnConvertDateToSQLFormat(vm.datevalend) : null,
                    LanguageId: 1,
                    Parameters: {
                        page: 1,
                        take: 10000,                        
                    }
                }
                return datacontext.equipmenttracking.getEquipmentTrackingByCriteria(model).then(function (data) {
                    if (data.Result == 1) {
                        if (data.EquipmentActivities.length > 0) {
                            vm.equipmentActivities = data.EquipmentActivities;
                            vm.viewEquipmentActivities = true;
                            vm.viewErrorEquipmentActivities = false;
                            vm.viewNoResultEquipmentActivities = false;
                            vm.selectDetail(vm.equipmentActivities[0], 0);
                        }
                        else {
                            vm.viewEquipmentActivities = false;
                            vm.viewNoResultEquipmentActivities = true;
                            vm.viewErrorEquipmentActivities = false;
                            vm.actionSearch = false;
                        }
                    }
                    else {
                        vm.viewEquipmentActivities = false;
                        vm.viewErrorEquipmentActivities = true;
                        vm.viewNoResultEquipmentActivities = false;e;
                        vm.actionSearch = false;
                    }
                }, function (err) {
                    vm.viewEquipmentActivities = false;
                    vm.viewErrorEquipmentActivities = true;
                    vm.viewNoResultEquipmentActivities = false;e;
                    vm.actionSearch = false;
                    if (err.status)
                        toastr.error(err.info);
                });
            }
            else {
                vm.actionSearch = false;
                toastr.info($translate.instant('views.equipmentTracking.selectEquipmentAutoComplete'));
            }
        }

        vm.boldStyle = function (id) {
            $('#id' + id).parent().parent().children('tr').children('td').css('font-weight', 'normal');
            $('#id' + id).css('font-weight', 'bold');
        }

        vm.viewDetailGTI = false;
        vm.viewDetailINS = false;
        vm.viewDetailPTI = false;
        vm.viewDetailGTO = false;
        vm.viewErrorDetail = false;
        // Variables detail GTI
        vm.appointmentNoGTI = '';
        vm.customerNameGTI = '';
        vm.depotOrderNoGTI = '';
        vm.driverNameGTI = '';
        vm.driverPassGTI = '';
        vm.endDateGTI = '';
        vm.licensePlateNoGTI = '';
        vm.EquipmentParentNoGTI = '';
        vm.movementTypeGTI = '';
        vm.referenceDocumentGTI = '';
        vm.startDateGTI = '';
        vm.statusColorGTI = '#FFFFFF';
        vm.statusNameGTI = '';
        vm.truckerNameGTI = '';
        vm.vesselNameGTI = '';
        vm.voyageNumberGTI = '';
        // Variables detail INS
        vm.statusNameINS = '';
        vm.statusColorINS = '#FFFFFF';
        vm.listINS = [];
        vm.totalINS = 0;
        // Variables detail PTI
        vm.statusNamePTI = '';
        vm.statusColorPTI = '#FFFFFF';
        vm.listPTI = [];
        vm.totalPTI = 0;
        // Variables detail GTO
        vm.appointmentNoGTO = '';
        vm.customerNameGTO = '';
        vm.depotOrderNoGTO = '';
        vm.driverNameGTO = '';
        vm.driverPassGTO = '';
        vm.endDateGTO = '';
        vm.licensePlateNoGTO = '';
        vm.EquipmentParentNoGTO = '';
        vm.movementTypeGTO = '';
        vm.referenceDocumentGTO = '';
        vm.startDateGTO = '';
        vm.statusColorGTO = '#FFFFFF';
        vm.statusNameGTO = '';
        vm.truckerNameGTO = '';
        vm.vesselNameGTO = '';
        vm.voyageNumberGTO = '';

        vm.selectDetail = function (equipt, id) {
            vm.actionSearch = true;
            switch (equipt.ActivityCode) {
                case 'GTI':
                    return datacontext.equipmenttracking.getEquipmentActivityGateOperation(equipt.EquipmentActivityId).then(function (data) {
                        if (data.Result == 1) {
                            if (data.EquipmentActivityGateOperation.RegisterCount == 0) {
                                vm.viewNoResultDetail = true;
                                vm.viewManyResultsDetail = false;
                                vm.viewErrorDetail = false;
                                vm.viewDetailGTI = false;
                                vm.viewDetailINS = false;
                                vm.viewDetailPTI = false;
                                vm.viewDetailGTO = false;
                            }
                            else {
                                if (data.EquipmentActivityGateOperation.RegisterCount == 1) {
                                    vm.appointmentNoGTI = data.EquipmentActivityGateOperation.AppointmentNo;
                                    vm.customerNameGTI = data.EquipmentActivityGateOperation.CustomerName;
                                    vm.depotOrderNoGTI = data.EquipmentActivityGateOperation.DepotOrderNo;
                                    vm.driverNameGTI = data.EquipmentActivityGateOperation.DriverName;
                                    vm.driverPassGTI = data.EquipmentActivityGateOperation.DriverPass;
                                    vm.endDateGTI = data.EquipmentActivityGateOperation.EndDate;
                                    vm.licensePlateNoGTI = data.EquipmentActivityGateOperation.LicensePlateNo;
                                    vm.EquipmentParentNoGTI = data.EquipmentActivityGateOperation.EquipmentParentNo;
                                    vm.movementTypeGTI = data.EquipmentActivityGateOperation.MovementType;
                                    vm.referenceDocumentGTI = data.EquipmentActivityGateOperation.ReferenceDocument;
                                    vm.startDateGTI = data.EquipmentActivityGateOperation.StartDate;
                                    vm.statusColorGTI = data.EquipmentActivityGateOperation.StatusColor;
                                    if (vm.statusColorGTI == null || vm.statusColorGTI == '') {
                                        vm.statusColorGTI = '#000000';
                                    }
                                    $("#statusColorGTI").css("background-color", vm.statusColorGTI);
                                    vm.statusNameGTI = data.EquipmentActivityGateOperation.StatusName;
                                    vm.truckerNameGTI = data.EquipmentActivityGateOperation.TruckerName;
                                    vm.vesselNameGTI = data.EquipmentActivityGateOperation.VesselName;
                                    vm.voyageNumberGTI = data.EquipmentActivityGateOperation.VoyageNumber;

                                    vm.viewNoResultDetail = false;
                                    vm.viewErrorDetail = false;
                                    vm.viewDetailGTI = true;
                                    vm.viewDetailINS = false;
                                    vm.viewDetailPTI = false;
                                    vm.viewDetailGTO = false;
                                    vm.viewManyResultsDetail = false;
                                }
                                else {
                                    vm.viewNoResultDetail = false;
                                    vm.viewErrorDetail = false;
                                    vm.viewDetailGTI = false;
                                    vm.viewDetailINS = false;
                                    vm.viewDetailPTI = false;
                                    vm.viewDetailGTO = false;
                                    vm.viewManyResultsDetail = true;
                                }
                            }
                        }
                        else {
                            vm.viewDetailGTI = false;
                            vm.viewDetailINS = false;
                            vm.viewDetailPTI = false;
                            vm.viewDetailGTO = false;
                            vm.viewErrorDetail = true;
                            vm.viewNoResultDetail = false;
                            vm.viewManyResultsDetail = false;
                        }
                        vm.boldStyle(id);
                        vm.actionSearch = false;
                    }, function (err) {
                        vm.viewDetailGTI = false;
                        vm.viewDetailINS = false;
                        vm.viewDetailPTI = false;
                        vm.viewDetailGTO = false;
                        vm.viewErrorDetail = true;
                        vm.viewNoResultDetail = false;
                        vm.viewManyResultsDetail = false;
                        vm.boldStyle(id);
                        vm.actionSearch = false;
                        if (err.status)
                            toastr.error(err.info);
                    });
                    break;
                case 'INS':
                    return datacontext.equipmenttracking.getEquipmentActivityInspection(equipt.EquipmentActivityId).then(function (data) {
                        if (data.Result == 1) {
                            if (data.EquipmentActivityInspection.RegisterCount == 0) {
                                vm.viewNoResultDetail = true;
                                vm.viewManyResultsDetail = false;
                                vm.viewErrorDetail = false;
                                vm.viewDetailGTI = false;
                                vm.viewDetailINS = false;
                                vm.viewDetailPTI = false;
                                vm.viewDetailGTO = false;
                            }
                            else {
                                if (data.EquipmentActivityInspection.RegisterCount == 1) {
                                    vm.statusNameINS = data.EquipmentActivityInspection.StatusName;
                                    vm.statusColorINS = data.EquipmentActivityInspection.StatusColor;
                                    if (vm.statusColorINS == null || vm.statusColorINS == '') {
                                        vm.statusColorINS = '#000000';
                                    }
                                    $("#statusColorINS").css("background-color", vm.statusColorINS);
                                    vm.listINS = data.EquipmentActivityInspection.InspectionDamages;
                                    vm.totalINS = 0;
                                    angular.forEach(vm.listINS, function (value, key) {
                                        if (value.TotalPrice == '' || value.TotalPrice == null) {
                                            value.TotalPrice = 0;
                                        }
                                        vm.totalINS = vm.totalINS + value.TotalPrice;
                                    });
                                    vm.viewDetailGTI = false;
                                    vm.viewDetailINS = true;
                                    vm.viewDetailPTI = false;
                                    vm.viewDetailGTO = false;
                                    vm.viewErrorDetail = false;
                                    vm.viewNoResultDetail = false;
                                    vm.viewManyResultsDetail = false;
                                }
                                else {
                                    vm.viewNoResultDetail = false;
                                    vm.viewErrorDetail = false;
                                    vm.viewDetailGTI = false;
                                    vm.viewDetailINS = false;
                                    vm.viewDetailPTI = false;
                                    vm.viewDetailGTO = false;
                                    vm.viewManyResultsDetail = true;
                                }
                            }
                        }
                        else {
                            vm.viewDetailGTI = false;
                            vm.viewDetailINS = false;
                            vm.viewDetailPTI = false;
                            vm.viewDetailGTO = false;
                            vm.viewErrorDetail = true;
                            vm.viewNoResultDetail = false;
                            vm.viewManyResultsDetail = false;
                        }
                        vm.boldStyle(id);
                        vm.actionSearch = false;
                    }, function (err) {
                        vm.viewDetailGTI = false;
                        vm.viewDetailINS = false;
                        vm.viewDetailPTI = false;
                        vm.viewDetailGTO = false;
                        vm.viewErrorDetail = true;
                        vm.viewNoResultDetail = false;
                        vm.viewManyResultsDetail = false;
                        vm.boldStyle(id);
                        vm.actionSearch = false;
                        if (err.status)
                            toastr.error(err.info);
                    });
                    break;
                case 'PTI':
                    return datacontext.equipmenttracking.getEquipmentActivityPTI(equipt.EquipmentActivityId).then(function (data) {
                        if (data.Result == 1) {
                            if (data.EquipmentActivityInspection.RegisterCount == 0) {
                                vm.viewNoResultDetail = true;
                                vm.viewManyResultsDetail = false;
                                vm.viewErrorDetail = false;
                                vm.viewDetailGTI = false;
                                vm.viewDetailINS = false;
                                vm.viewDetailPTI = false;
                                vm.viewDetailGTO = false;
                            }
                            else {
                                if (data.EquipmentActivityInspection.RegisterCount == 1) {
                                    vm.statusNamePTI = data.EquipmentActivityInspection.StatusName;
                                    vm.statusColorPTI = data.EquipmentActivityInspection.StatusColor;
                                    if (vm.statusColorPTI == null || vm.statusColorPTI == '') {
                                        vm.statusColorPTI = '#000000';
                                    }
                                    $("#statusColorPTI").css("background-color", vm.statusColorPTI);
                                    vm.listPTI = data.EquipmentActivityInspection.InspectionDamages;
                                    vm.totalPTI = 0;
                                    angular.forEach(vm.listPTI, function (value, key) {
                                        if (value.TotalPrice == '' || value.TotalPrice == null) {
                                            value.TotalPrice = 0;
                                        }
                                        vm.totalPTI = vm.totalPTI + value.TotalPrice;
                                    });
                                    vm.viewDetailGTI = false;
                                    vm.viewDetailINS = false;
                                    vm.viewDetailPTI = true;
                                    vm.viewDetailGTO = false;
                                    vm.viewErrorDetail = false;
                                    vm.viewNoResultDetail = false;
                                    vm.viewManyResultsDetail = false;
                                }
                                else {
                                    vm.viewNoResultDetail = false;
                                    vm.viewErrorDetail = false;
                                    vm.viewDetailGTI = false;
                                    vm.viewDetailINS = false;
                                    vm.viewDetailPTI = false;
                                    vm.viewDetailGTO = false;
                                    vm.viewManyResultsDetail = true;
                                }
                            }
                        }
                        else {
                            vm.viewDetailGTI = false;
                            vm.viewDetailINS = false;
                            vm.viewDetailPTI = false;
                            vm.viewDetailGTO = false;
                            vm.viewErrorDetail = true;
                            vm.viewNoResultDetail = false;
                            vm.viewManyResultsDetail = false;
                        }
                        vm.boldStyle(id);
                        vm.actionSearch = false;
                    }, function (err) {
                        vm.viewDetailGTI = false;
                        vm.viewDetailINS = false;
                        vm.viewDetailPTI = false;
                        vm.viewDetailGTO = false;
                        vm.viewErrorDetail = true;
                        vm.viewNoResultDetail = false;
                        vm.viewManyResultsDetail = false;
                        vm.boldStyle(id);
                        vm.actionSearch = false;
                        if (err.status)
                            toastr.error(err.info);
                    });
                    break;
                case 'GTO':
                    return datacontext.equipmenttracking.getEquipmentActivityGateOperation(equipt.EquipmentActivityId).then(function (data) {
                        if (data.Result == 1) {
                            if (data.EquipmentActivityGateOperation.RegisterCount == 0) {
                                vm.viewNoResultDetail = true;
                                vm.viewManyResultsDetail = false;
                                vm.viewErrorDetail = false;
                                vm.viewDetailGTI = false;
                                vm.viewDetailINS = false;
                                vm.viewDetailPTI = false;
                                vm.viewDetailGTO = false;
                            }
                            else {
                                if (data.EquipmentActivityGateOperation.RegisterCount == 1) {
                                    vm.appointmentNoGTO = data.EquipmentActivityGateOperation.AppointmentNo;
                                    vm.customerNameGTO = data.EquipmentActivityGateOperation.CustomerName;
                                    vm.depotOrderNoGTO = data.EquipmentActivityGateOperation.DepotOrderNo;
                                    vm.driverNameGTO = data.EquipmentActivityGateOperation.DriverName;
                                    vm.driverPassGTO = data.EquipmentActivityGateOperation.DriverPass;
                                    vm.endDateGTO = data.EquipmentActivityGateOperation.EndDate;
                                    vm.licensePlateNoGTO = data.EquipmentActivityGateOperation.LicensePlateNo;
                                    vm.EquipmentParentNoGTO = data.EquipmentActivityGateOperation.EquipmentParentNo;
                                    vm.movementTypeGTO = data.EquipmentActivityGateOperation.MovementType;
                                    vm.referenceDocumentGTO = data.EquipmentActivityGateOperation.ReferenceDocument;
                                    vm.startDateGTO = data.EquipmentActivityGateOperation.StartDate;
                                    vm.statusColorGTO = data.EquipmentActivityGateOperation.StatusColor;
                                    if (vm.statusColorGTO == null || vm.statusColorGTO == '') {
                                        vm.statusColorGTO = '#000000';
                                    }
                                    $("#statusColorGTO").css("background-color", vm.statusColorGTO);
                                    vm.statusNameGTO = data.EquipmentActivityGateOperation.StatusName;
                                    vm.truckerNameGTO = data.EquipmentActivityGateOperation.TruckerName;
                                    vm.vesselNameGTO = data.EquipmentActivityGateOperation.VesselName;
                                    vm.voyageNumberGTO = data.EquipmentActivityGateOperation.VoyageNumber;

                                    vm.viewDetailGTI = false;
                                    vm.viewDetailINS = false;
                                    vm.viewDetailPTI = false;
                                    vm.viewDetailGTO = true;
                                    vm.viewErrorDetail = false;
                                    vm.viewNoResultDetail = false;
                                    vm.viewManyResultsDetail = false;
                                }
                                else {
                                    vm.viewNoResultDetail = false;
                                    vm.viewErrorDetail = false;
                                    vm.viewDetailGTI = false;
                                    vm.viewDetailINS = false;
                                    vm.viewDetailPTI = false;
                                    vm.viewDetailGTO = false;
                                    vm.viewManyResultsDetail = true;
                                }
                            }
                        }
                        else {
                            vm.viewDetailGTI = false;
                            vm.viewDetailINS = false;
                            vm.viewDetailPTI = false;
                            vm.viewDetailGTO = false;
                            vm.viewErrorDetail = true;
                            vm.viewNoResultDetail = false;
                            vm.viewManyResultsDetail = false;
                        }
                        vm.boldStyle(id);
                        vm.actionSearch = false;
                    }, function (err) {
                        vm.viewDetailGTI = false;
                        vm.viewDetailINS = false;
                        vm.viewDetailPTI = false;
                        vm.viewDetailGTO = false;
                        vm.viewErrorDetail = true;
                        vm.viewNoResultDetail = false;
                        vm.viewManyResultsDetail = false;
                        vm.boldStyle(id);
                        vm.actionSearch = false;
                        if (err.status)
                            toastr.error(err.info);
                    });
                    break;
                default:
                    vm.viewDetailGTI = false;
                    vm.viewDetailINS = false;
                    vm.viewDetailPTI = false;
                    vm.viewDetailGTO = false;
                    vm.viewErrorDetail = false;
                    vm.viewNoResultDetail = true;
                    vm.viewManyResultsDetail = false;
                    $timeout(function () {
                        vm.boldStyle(id);
                        vm.actionSearch = false;
                    }, 5);
            }
        }

        vm.addScroll = function () {
            return vm.equipmentActivities.length >= CONSTANTS.QUANTITY_BASE_SCROLL ? 'table-y-300' : '';
        };

        vm.addScrollINS = function () {
            return vm.listINS.length >= CONSTANTS.QUANTITY_BASE_SCROLL_INS ? 'table-y-200' : '';
        };

        vm.addScrollPTI = function () {
            return vm.listPTI.length >= CONSTANTS.QUANTITY_BASE_SCROLL_PTI ? 'table-y-200' : '';
        };

        function ClearViews() {
            vm.viewEquipmentInformation = false;
            vm.viewEquipmentActivities = false;
            vm.viewNoResultEquipmentActivities = false;
            vm.viewErrorEquipmentActivities = false;
            vm.viewErrorInformation = false;
            vm.viewNoResultInformation = false;
        }

        init();        
    }
})();